// Built-in royalty-free (self-generated) worship/instrumental clips for stories.
export const STORY_MUSIC = [
  { key: "adoration", title: "Adoration", url: "/music/adoration.wav", i18nKey: "music.track.adoration" },
  { key: "louange", title: "Louange", url: "/music/louange.wav", i18nKey: "music.track.louange" },
  { key: "paix", title: "Paix profonde", url: "/music/paix.wav", i18nKey: "music.track.paix" },
  { key: "esperance", title: "Espérance", url: "/music/esperance.wav", i18nKey: "music.track.esperance" },
  { key: "priere", title: "Prière", url: "/music/priere.wav", i18nKey: "music.track.priere" },
  { key: "joie", title: "Joie", url: "/music/joie.wav", i18nKey: "music.track.joie" },
  { key: "gloire", title: "Gloire", url: "/music/gloire.wav", i18nKey: "music.track.gloire" },
  { key: "repos", title: "Repos", url: "/music/repos.wav", i18nKey: "music.track.repos" },
  { key: "gratitude", title: "Gratitude", url: "/music/gratitude.wav", i18nKey: "music.track.gratitude" },
  { key: "meditation", title: "Méditation", url: "/music/meditation.wav", i18nKey: "music.track.meditation" },
  { key: "ciel", title: "Ciel ouvert", url: "/music/ciel.wav", i18nKey: "music.track.ciel" },
  { key: "force", title: "Force", url: "/music/force.wav", i18nKey: "music.track.force" },
  { key: "reveil", title: "Réveil", url: "/music/reveil.wav", i18nKey: "music.track.reveil" },
];

// Admin-managed music library (falls back to the built-in defaults above when empty/offline).
export const fetchMusicLibrary = async () => {
  try {
    const { api } = await import("@/lib/api");
    const { data } = await api.get("/music/library");
    const tracks = Array.isArray(data?.tracks) ? data.tracks : [];
    return tracks.length
      ? tracks.map((tk) => ({ key: tk.id, title: tk.title, url: tk.url, uses: tk.uses || 0, featured: !!tk.featured, i18nKey: tk.i18n_key || null, category: tk.category || null }))
      : STORY_MUSIC;
  } catch {
    return STORY_MUSIC;
  }
};
